import { render, staticRenderFns } from "./WinnerEdit.vue?vue&type=template&id=5cb61657&lang=pug"
import script from "./WinnerEdit.vue?vue&type=script&lang=js"
export * from "./WinnerEdit.vue?vue&type=script&lang=js"
import style0 from "./WinnerEdit.vue?vue&type=style&index=0&id=5cb61657&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports